export const micrositeStyles = {
  muktijuddho: {
    primaryBgColor: "#ffc107",
    hamburgerColor: "#001246",
    searchColor: "#001246",
    bellIcon: "#001246",
    loginText: "#001246",
    loginBorder: "#001246",
    socialIconBg: "#eee",
    fontColor: "#121212",
    navbarBgColor: "#fff",
    navbarStickyColor: "#ffc107",
    hamburgerHeaderColor: "#fff",
  },
};
